import React from 'react';
import styles from './formsBrowser.module.scss';
import { getIsFormFavorited } from './services/formsBrowserService';
import { Icon } from '../../components/icon/Icon';
import { LocalStorageProps, SelectionProps } from './types/FormTypes';

export const FavoriteIcon = React.memo(
    (props: {
        selectionProps: SelectionProps;
        localStorageProps: LocalStorageProps;
    }) => {
        try {
            const {
                selectionProps: {
                    formSelected,
                    handleOnFormFavorite,
                    handleOnFormUnfavorite,
                },
                localStorageProps: { favoritedFormIds },
            } = props;

            const isFormFavorited = getIsFormFavorited(
                favoritedFormIds,
                formSelected,
            );

            if (isFormFavorited) {
                return (
                    <div className={styles.formFavoriteIconContainer}>
                        <Icon
                            icon="star"
                            color="black"
                            size="large"
                            onClick={() => handleOnFormUnfavorite()}
                            ariaLabel="Remove from favorites"
                        />
                    </div>
                );
            } else {
                return (
                    <div className={styles.formFavoriteIconContainer}>
                        <Icon
                            icon="star outline"
                            color="black"
                            size="large"
                            onClick={() => handleOnFormFavorite()}
                            ariaLabel="Add to favorites"
                        />
                    </div>
                );
            }
        } catch {
            return null;
        }
    },
);
